<template>
    <div class="relative">
        <button
            @click="isDropdownVisible = !isDropdownVisible"
            :aria-expanded="isDropdownVisible"
            :class="{
                '!bg-gray-tier-6': isDropdownVisible,
            }"
            class="btn-app-icon-black-on-gray px-3 flex items-center gap-2 group"
        >
            <BaseSvg name="Share" aria-hidden="true" class="type-tertiary h-5 group-hover:type-secondary" :class="{
                '!type-secondary': isDropdownVisible,
            }" />
            <span class="text-sm">{{ $t('Share') }}</span>
        </button>
        <div
            v-click-outside="closeDropdown"
            v-if="isDropdownVisible"
            class="
                absolute 
                p-5 right-0 
                rounded-md 
                top-full 
                translate-x-[212px] 
                translate-y-[15px] 
                w-[calc(var(--app-detail-aside-width)_-_4rem)] 
                z-10
                dark:bg-v2-gray-50
                bg-v2-white
                border border-gray-225 dark:border-gray-850 shadow-black/20 shadow-xl
            "
        >
            <ul class="space-y-2">
                <ShareByEmail />
                <CopyButton />
                <DownloadPdfButton />
            </ul>
        </div>
    </div>
</template>

<script setup>
import {ref} from "vue";
import { ShareByEmail, CopyButton, DownloadPdfButton } from "@/Components/Modules/ProductDetail/TopButtons/"

const isDropdownVisible = ref(false);

function closeDropdown () {
    isDropdownVisible.value = false;
}
</script>
